import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

// Externals
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import validate from 'validate.js';
import _ from 'underscore';

// Material helpers
import { withStyles } from '@material-ui/core/styles/index';

// Material components
import Grid from '@material-ui/core/Grid/index';
import Button from '@material-ui/core/Button/index';
import CircularProgress from '@material-ui/core/CircularProgress/index';
import IconButton from '@material-ui/core/IconButton/index';
import TextField from '@material-ui/core/TextField/index';
import Typography from '@material-ui/core/Typography/index';
import ErrorIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

// Component styles
import styles from './styles';

// Form validation schema
import schema from './schema';
import { api_host, CLIENTE_ID_PICHINCHA } from '../../common/globals/constants';
import { getQueryParams } from '../../utils/fns/get-query-params';
import { getClienteInfo } from '../../services/getClienteInfo';
import { withTranslation } from 'react-i18next';

// Service methods
const specialAcces = (email, pass, user) => {
    return new Promise(resolve => {
        setTimeout(() => {
            fetch(api_host + '/api-auth-reporte-admin/', {
                method: 'POST', // or 'PUT'
                body: JSON.stringify({
                    email: email,
                    password: pass, user: user
                }), // data can be `string` or {object}!
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => res.json())
                .catch(error => console.error('Error:', error))
                .then(response => {
                    if (typeof (response) === 'undefined' || (response.status == 0 && !response.data)) {
                        sessionStorage.setItem('statusError', -1000)
                        resolve(false);
                    } else if (response.status == 1) {
                        sessionStorage.setItem('statusError', response.status)
                        resolve(false);
                    }else if (response.status == 5) {
                        sessionStorage.setItem('statusError', response.status)
                        resolve(false);
                    }else if (response.status == 6) {
                        sessionStorage.setItem('statusError', response.status)
                        resolve(false);
                    } else {
                        try {
                            sessionStorage.setItem('key', response.data.token)
                            sessionStorage.setItem('user', response.data.cliente_usuario_id)
                            sessionStorage.setItem('user_name', response.data.nombre_usuario)
                            sessionStorage.setItem('client_id', response.data.cliente_id)
                            sessionStorage.setItem('email', response.data.email)
                            sessionStorage.setItem('profile', response.data.perfil.nombre)
                            sessionStorage.setItem('profile_id', response.data.perfil.reporte_perfil_id)
                            sessionStorage.setItem('client_name', response.data.cliente.nombre)
                            sessionStorage.setItem('admin', response.data.admin.nombre)
                            sessionStorage.setItem('idioma_preferido', response.data.idioma_preferido)
                            sessionStorage.setItem('admin_id', response.data.admin.admin_usuario_id)
                            sessionStorage.setItem('tz', response.data.zona_horaria.valor)
                            sessionStorage.setItem('period_semaphore', response.data.preferencia_semaforo_periodo)
                            sessionStorage.setItem('max_horariohabil', response.data.cliente.max_horariohabil)
                            sessionStorage.setItem('fechaLogin', new Date().getTime())
                            resolve(true);
                        } catch(err) {
                            sessionStorage.setItem('statusError', 100)
                            resolve(false);
                        }
                    }
                }
                );
        }, 100);
    });
};



class SpecialAcces extends Component {
    constructor(props) {

        //Asignación de helper para prellenado de mail
        let mail = props.location.search.split("=")[1] ?
            props.location.search.split("=")[0] === "?email" ?
                props.location.search.split("=")[1] : "" : "";

        sessionStorage.setItem('statusError', 0)
        super(props);
        this.state = {
            values: {
                email: decodeURIComponent(mail),
                password: '',
                emailAdmin: ''
            },
            touched: {
                email: false,
                password: false,
                emailAdmin: false
            },
            errors: {
                email: null,
                password: null,
                emailAdmin: null
            },
            isValid: false,
            isLoading: false,
            submitError: null,
            open: false,
            openModal: false,
            emailPass: "",
            colorCall: "",
            call: "",
            display: "none"
        };
    }

    handleBack = () => {
        const { history } = this.props;

        history.goBack();
    };

    validateForm = _.debounce(() => {
        const { values } = this.state;
        const newState = { ...this.state };
        const errors = validate(values, schema);
        newState.errors = errors || {};
        newState.isValid = errors ? false : true;
        this.setState(newState);
    }, 300);

    handleFieldChange = (field, value) => {
        const newState = { ...this.state };
        newState.submitError = null;
        newState.touched[field] = true;
        newState.values[field] = value;

        this.setState(newState, this.validateForm);
    };

    handleSignIn = async () => {
        sessionStorage.clear()
        try {
            const { history } = this.props;
            const { values } = this.state;
            this.setState({ isLoading: true });
            await specialAcces(values.emailAdmin, values.password, values.email);
            if (sessionStorage.length > 1) {
                try {
                    const { changeLanguage } = require('../../i18n');
                    const preferred = sessionStorage.getItem('idioma_preferido');
                    if (preferred && ['es', 'en', 'pt'].includes(preferred)) {
                        changeLanguage(preferred);
                    }
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.warn('No se pudo aplicar idioma_preferido tras login', e);
                }

                localStorage.setItem('isAuthenticated', true);

                // Verificar acceso a Métricas
                try {
                    const clienteInfo = await getClienteInfo();
                    sessionStorage.setItem('acceso_metricas', clienteInfo.autorizado === true);
                } catch (e) {
                    console.warn('No se pudo verificar acceso a Métricas', e);
                    sessionStorage.setItem('acceso_metricas', false);
                }

                // Verificar acceso a dashboard pichincha
                try {
                    const clienteInfo = await getClienteInfo(CLIENTE_ID_PICHINCHA);
                    sessionStorage.setItem('acceso_dashboard_pichincha', clienteInfo.autorizado === true);
                } catch (e) {
                    console.warn('No se pudo verificar acceso a Métricas', e);
                    sessionStorage.setItem('acceso_dashboard_pichincha', false);
                }

                history.push({ pathname: '/home', search: getQueryParams() });
            } else {
                this.setState({
                    isLoading: false,
                    isValid: false,
                    touched: {
                        email: false,
                        password: false,
                        emailAdmin: false
                    },
                    open: true
                });
            }

        } catch (error) {
            this.setState({
                isLoading: false,
                serviceError: error,
                isValid: false,
                open: true
            });
        }
    };

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({
            open: false
        })
    };



    getSite = () => {
        window.open('https://www.atentus.com', '_blank');
    }

    onOpenModal = () => {
        this.setState({
            openModal: true,
        });
    };

    onCloseModal = () => {
        this.setState({ openModal: false });
    };


    render() {

        const { classes } = this.props;
        const t = (this.props && typeof this.props.t === 'function') ? this.props.t : (key => key);
        const {
            values,
            touched,
            errors,
            isValid,
            submitError,
            isLoading,
            open,
            openModal,
            emailPass,
            display,
            call,
            colorCall
        } = this.state;
        let status = sessionStorage.getItem('statusError')
        var statusMesagge = ''
        if (status == 1) {
            statusMesagge = t('signin.error.invalid')
        } else if (status == 5) {
            statusMesagge = t('signin.error.request_beta')
        } else if (status == 6) {
            statusMesagge = t('signin.error.expired')
        } else if (status == 100) {
            statusMesagge = t('signin.error.expired')
        } else if (status == -1000 ) {
            statusMesagge = t('signin.mfa_code.error.unknown')
        }

        const showEmailError = touched.email && errors.email
        const showEmailAdminError = errors.emailAdmin && touched.emailAdmin
        const showPasswordError = touched.password && errors.password;
        return (
            <Grid
                className={classes.root}
                container
            >
                <Grid
                    item
                    lg={12}
                    xs={12}
                    xl={12}
                >
                    <div style={{ textAlign: "center", paddingTop: "5%" }}>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >
                            <Grid>
                                <img
                                    alt="Atentus logo"
                                    className={classes.logoImage}
                                    src="/images/logos/logo-atentus-azul.svg"
                                    height="50px"
                                />
                            </Grid>
                        </Grid>
                        <Grid style={{ paddingTop: "20px" }}>
                            <Typography
                                className={classes.textWhite}
                                variant="h3"
                            >
                                Acceso Especial
                            </Typography>
                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: "10px" }}>
                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                            >
                                <Grid>
                                    <div className={classes.divIcon}>
                                        <PersonOutlineOutlinedIcon fontSize="large" className={classes.iconIn} />
                                    </div>
                                </Grid>
                                <Grid>
                                    <TextField
                                        className={classes.textField}
                                        label="Usuario"
                                        name="email"
                                        onChange={event =>
                                            this.handleFieldChange('email', event.target.value)
                                        }
                                        type="text"
                                        value={values.email}
                                        variant="outlined"

                                    />
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: "10px" }}>
                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                            >
                                <Grid>
                                    <div className={classes.divIcon}>
                                        <PersonOutlineOutlinedIcon fontSize="large" className={classes.iconIn} />
                                    </div>
                                </Grid>
                                <Grid>
                                    <TextField
                                        className={classes.textField}
                                        label="Usuario Admin"
                                        name="email Admin"
                                        onChange={event =>
                                            this.handleFieldChange('emailAdmin', event.target.value)
                                        }
                                        type="text"
                                        value={values.emailAdmin}
                                        variant="outlined"
                                        onKeyDown={event => {
                                            if (event.key === 'Enter') {
                                                this.handleSignIn();
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid item xs={12} style={{ paddingTop: "5px" }}>

                            <Grid
                                container
                                direction="row"
                                justify="center"
                                alignItems="center"
                            >
                                <Grid>
                                    <div className={classes.divIcon}>
                                        <LockOutlinedIcon fontSize="large" className={classes.iconIn} />
                                    </div>
                                </Grid>
                                <Grid>
                                    <TextField
                                        className={classes.textField}
                                        label="Contraseña Admin"
                                        name="password Admin"
                                        onChange={event =>
                                            this.handleFieldChange('password', event.target.value)
                                        }
                                        type="password"
                                        value={values.password}
                                        variant="outlined"
                                        onKeyDown={event => {
                                            if (event.key === 'Enter') {
                                                this.handleSignIn();
                                            }
                                        }}
                                    />

                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid style={{ paddingTop: "10px", paddingBottom: "40px" }}>
                            {submitError && (
                                <Typography
                                    className={classes.submitError}
                                    variant="body2"
                                >
                                    {submitError}
                                </Typography>
                            )}
                            {isLoading ? (
                                <CircularProgress className={classes.progress} />
                            ) : (
                                <Button
                                    className={classes.signInButton}
                                    color="primary"
                                    disabled={!isValid}
                                    onClick={this.handleSignIn}
                                    size="large"
                                    variant="contained"
                                >
                                    Ingresar
                                </Button>
                            )
                            }
                            {isValid ? (
                                null
                            ) : (
                                <Snackbar
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }}
                                    open={open}
                                    autoHideDuration={6000}
                                    onClose={this.handleClose}
                                >
                                    <SnackbarContent
                                        className={classes.snackContent}
                                        aria-describedby="client-snackbar"
                                        message={
                                            <span id="client-snackbar" className={classes.message}>
                                                <ErrorIcon className={(classes.icon, classes.iconVariant)} />
                                                {statusMesagge}
                                            </span>
                                        }
                                        action={[
                                            <IconButton key="close" aria-label="close" color="inherit" onClick={this.handleClose}>
                                                <CloseIcon className={classes.icon} />
                                            </IconButton>
                                        ]}
                                    />

                                </Snackbar>


                            )}

                        </Grid>
                    </div>
                </Grid>
            </Grid>
        );
    }
}

SpecialAcces.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
};


export default compose(
    withRouter,
    withTranslation(),
    withStyles(styles)
)(SpecialAcces);
